import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaicabservice() {



    const cardData = {

keyword: "Mumbai Cab Service",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai Cab Service for airport transfers, local city rides, corporate travel, family outings, weddings, sightseeing, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup and drop across Mumbai, instant booking support, and safe driving, we ensure a smooth, comfortable, and hassle-free travel experience for all passengers in and around Mumbai.",

topPlaces: [
    {
        title: "Gateway of India",
        description:
            "Gateway of India is one of Mumbai’s most iconic landmarks overlooking the Arabian Sea. It is a major tourist attraction for local sightseeing and ferry rides to Elephanta Caves."
    },
    {
        title: "Marine Drive",
        description:
            "Marine Drive is a famous coastal boulevard known as the Queen’s Necklace. It is a popular spot for evening drives, sightseeing, and relaxing sea views."
    },
    {
        title: "Juhu Beach",
        description:
            "Juhu Beach is one of Mumbai’s most visited beaches known for street food, sunsets, and weekend leisure activities for families and tourists."
    },
    {
        title: "Siddhivinayak Temple",
        description:
            "Siddhivinayak Temple is a highly revered Ganesh temple in Mumbai visited by thousands of devotees daily for blessings and spiritual experience."
    },
    {
        title: "Bandra-Worli Sea Link",
        description:
            "Bandra-Worli Sea Link is a modern engineering marvel offering smooth connectivity and scenic views of Mumbai’s coastline, especially during night drives."
    },
    {
        title: "Elephanta Caves",
        description:
            "Elephanta Caves are a UNESCO World Heritage Site located on Elephanta Island, famous for ancient rock-cut caves and historical sculptures."
    },
    {
        title: "Haji Ali Dargah",
        description:
            "Haji Ali Dargah is a famous mosque and tomb located in the sea, attracting devotees and visitors for its spiritual importance and unique location."
    },
    {
        title: "Colaba Causeway",
        description:
            "Colaba Causeway is a popular shopping street in South Mumbai known for fashion, street shopping, cafes, and vibrant city life."
    },
    {
        title: "Chhatrapati Shivaji Maharaj Terminus",
        description:
            "CST is a UNESCO World Heritage railway station known for its Victorian Gothic architecture and historical significance in Mumbai."
    },
    {
        title: "Powai Lake",
        description:
            "Powai Lake is a peaceful urban lake surrounded by greenery and modern infrastructure, popular for evening relaxation and photography."
    }
],



services: [
{
name: "Mumbai Cab Service",
description: "Mumbai Airport Cab offers Mumbai Cab Service for safe, reliable, and comfortable transportation across the city and nearby destinations. Whether you need travel for airport transfers, local commuting, business meetings, family outings, sightseeing, or outstation trips, we provide a wide range of well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars. Our professional chauffeurs ensure punctual pickup, smooth driving, and safe travel experience. With transparent pricing, easy booking, doorstep service, and 24x7 availability, we make travel in Mumbai simple, convenient, and stress-free."
},
{
name: "Best Mumbai Cab Service",
description: "Best Mumbai Cab Service by Mumbai Airport Cab is designed to provide premium-quality transportation with maximum comfort and reliability. Our service includes clean vehicles, experienced chauffeurs, flexible travel options, and customer-focused support. Whether it is airport transfer, corporate travel, family trip, or long-distance journey, we ensure high service standards, safety, and comfort for every passenger across Mumbai and beyond."
},
{
name: "Mumbai Taxi Service",
description: "Mumbai Airport Cab provides Mumbai Taxi Service for local and intercity travel needs with professional drivers and well-maintained vehicles. Our taxis are ideal for daily commuting, airport pickups, business travel, shopping trips, and sightseeing tours. We ensure affordable pricing, timely service, and a smooth travel experience for all passengers."
},
{
name: "Local Cab Service Mumbai",
description: "Local Cab Service Mumbai offers convenient transportation within the city for office travel, market visits, hospital appointments, school pickups, and daily commuting. Mumbai Airport Cab provides comfortable vehicles, experienced drivers, and flexible booking options to ensure safe and efficient city travel at any time."
},
{
name: "Mumbai Ride Service",
description: "Mumbai Ride Service by Mumbai Airport Cab ensures quick and reliable transportation for short-distance and on-demand travel across Mumbai. With professional chauffeurs, clean vehicles, and instant booking options, we make city travel fast, safe, and comfortable for every passenger."
},
{
name: "Mumbai Car Hire Service",
description: "Mumbai Car Hire Service provides flexible vehicle rental solutions for local and outstation travel. Mumbai Airport Cab offers a wide fleet of cars with professional drivers, suitable for business trips, family travel, sightseeing, and airport transfers. We ensure comfort, safety, and affordability in every journey."
},
{
name: "Mumbai Outstation Cab Service",
description: "Mumbai Outstation Cab Service offers reliable long-distance travel to destinations like Pune, Nashik, Goa, Shirdi, Lonavala, Mahabaleshwar, and more. Mumbai Airport Cab provides comfortable vehicles, experienced chauffeurs, and flexible travel plans for safe and enjoyable intercity journeys."
},
{
name: "Mumbai Airport Cab Service",
description: "Mumbai Airport Cab Service provides timely pickup and drop services for domestic and international terminals. Our chauffeurs track flight timings, assist with luggage, and ensure smooth and stress-free airport transfers with 24x7 availability and reliable support."
},
{
name: "24x7 Mumbai Cab Service",
description: "24x7 Mumbai Cab Service ensures round-the-clock transportation availability for emergency travel, airport transfers, late-night rides, early morning trips, and urgent bookings. Mumbai Airport Cab guarantees safe, reliable, and quick response service anytime in Mumbai."
},
{
name: "Affordable Mumbai Cab Service",
description: "Affordable Mumbai Cab Service offers budget-friendly travel solutions without compromising comfort and safety. Mumbai Airport Cab provides transparent pricing, clean vehicles, and professional drivers for local and outstation travel at economical rates."
},
{
name: "Mumbai Online Cab Booking",
description: "Mumbai Online Cab Booking service allows customers to easily book rides through a quick and hassle-free process. Mumbai Airport Cab ensures instant confirmation, multiple vehicle options, transparent pricing, and reliable customer support for seamless booking experience."
},
{
name: "Mumbai Instant Cab Service",
description: "Mumbai Instant Cab Service provides quick ride availability for urgent travel needs. Mumbai Airport Cab ensures fast dispatch of nearby vehicles with professional drivers for immediate pickup and smooth travel across Mumbai."
},
{
name: "Mumbai City Cab Service",
description: "Mumbai City Cab Service offers comfortable transportation across all areas of Mumbai including business hubs, residential zones, tourist attractions, and shopping districts. We ensure safe, affordable, and efficient city travel with professional chauffeurs."
},
{
name: "Mumbai Premium Cab Service",
description: "Mumbai Premium Cab Service provides high-end transportation with luxury vehicles, professional chauffeurs, and superior comfort. Ideal for VIP travel, corporate clients, weddings, and special occasions requiring premium service standards."
},
{
name: "Mumbai Budget Cab Service",
description: "Mumbai Budget Cab Service offers economical travel options for daily commuting, airport transfers, and short trips. Mumbai Airport Cab ensures affordable pricing, reliable drivers, and comfortable vehicles for cost-effective travel."
},
{
name: "Mumbai Corporate Cab Service",
description: "Mumbai Corporate Cab Service is designed for business professionals and companies requiring reliable transportation for meetings, office travel, and client visits. We offer punctual service, executive vehicles, and professional chauffeurs for smooth corporate travel."
},
{
name: "Mumbai Family Cab Service",
description: "Mumbai Family Cab Service provides safe and comfortable travel for families across the city and for outstation trips. Mumbai Airport Cab offers spacious vehicles, experienced drivers, and flexible booking options for family-friendly transportation."
},
{
name: "Mumbai Tour Cab Service",
description: "Mumbai Tour Cab Service offers sightseeing and city exploration packages covering popular attractions, beaches, heritage sites, and cultural spots. Our professional drivers ensure a comfortable and guided travel experience for tourists."
},
{
name: "Mumbai Reliable Cab Service",
description: "Mumbai Reliable Cab Service ensures safe, punctual, and dependable transportation for all types of travel needs. Mumbai Airport Cab focuses on customer satisfaction, well-maintained vehicles, and professional service for a trustworthy travel experience."
}
],

tableData: [
["Mumbai Cab Service","Best Mumbai Cab Service"],
["Mumbai Taxi Service","Local Cab Service Mumbai"],
["Mumbai Ride Service","Mumbai Car Hire Service"],
["Mumbai Outstation Cab Service","Mumbai Airport Cab Service"],
["24x7 Mumbai Cab Service","Affordable Mumbai Cab Service"],
["Mumbai Online Cab Booking","Mumbai Instant Cab Service"],
["Mumbai City Cab Service","Mumbai Premium Cab Service"],
["Mumbai Budget Cab Service","Mumbai Corporate Cab Service"],
["Mumbai Family Cab Service","Mumbai Tour Cab Service"],
["Mumbai Reliable Cab Service","Mumbai Travel Cab Service"]
],








whychoose: [
    {
        WhyChooseheading: "Trusted Mumbai Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides reliable Mumbai Cab Services for airport transfers, local travel, outstation journeys, corporate transportation, sightseeing tours, and daily commuting requirements."
    },
    {
        WhyChooseheading: "24x7 Cab Availability Across Mumbai",
        WhyChoosedescription: "Our cab service operates round the clock, allowing customers to book comfortable transportation anytime for business travel, family functions, airport pickups, and emergency travel."
    },
    {
        WhyChooseheading: "Local and Outstation Travel Solutions",
        WhyChoosedescription: "Whether you need a cab within Mumbai or for destinations like Pune, Nashik, Shirdi, Mahabaleshwar, Goa, Ahmedabad, Hyderabad, and Bangalore, we provide dependable travel options."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide seamless airport transfers to and from Mumbai Airport with timely pickups, professional drivers, and comfortable vehicles."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, punctual service, route expertise, and customer satisfaction throughout every journey."
    },
    {
        WhyChooseheading: "Corporate and Executive Travel Services",
        WhyChoosedescription: "Many companies, business professionals, and executives rely on our cab services for meetings, conferences, airport transfers, and employee transportation."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Groups",
        WhyChoosedescription: "From solo travelers and families to corporate teams and tourist groups, we provide suitable transportation solutions for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "What services are included in Mumbai Cab Service?",
        answer: "Mumbai Airport Cabs offers airport transfers, local city travel, outstation trips, corporate transportation, sightseeing tours, employee transport, and customized travel solutions."
    },
    {
        question: "Can I book a cab for Mumbai Airport transfers?",
        answer: "Yes, airport pickup and drop services are available for domestic and international travelers at Mumbai Airport."
    },
    {
        question: "Which vehicles are available for booking?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
    },
    {
        question: "Do you provide outstation cab services from Mumbai?",
        answer: "Yes, outstation cab services are available for Pune, Nashik, Shirdi, Goa, Lonavala, Mahabaleshwar, Ahmedabad, Hyderabad, Bangalore, Jaipur, and many other destinations."
    },
    {
        question: "Can corporate clients use your cab services regularly?",
        answer: "Yes, we provide transportation solutions for executives, employees, business travelers, and corporate organizations."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family tours, weddings, corporate outings, educational trips, and group transportation."
    },
    {
        question: "Can I schedule a cab in advance?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
    },
    {
        question: "Do you provide Mumbai sightseeing cab services?",
        answer: "Yes, customers can book cabs for Mumbai Darshan, shopping tours, tourist attractions, and customized sightseeing itineraries."
    },
    {
        question: "Are your drivers experienced and verified?",
        answer: "Yes, all drivers are professionally trained, experienced, and familiar with local and outstation travel routes."
    },
    {
        question: "How can I book a Mumbai Cab Service?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akshay Mehra",
        feedback:
            "I regularly use Mumbai Airport Cabs for airport transfers and business travel. Their punctuality, clean vehicles, and professional drivers make every journey comfortable and stress-free.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Desai",
        feedback:
            "Our family booked a cab for a weekend trip and the experience was excellent. The vehicle was spacious, the driver was courteous, and the entire journey was smooth from beginning to end.",
        rating: 5
    }
];







































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai Cab Service",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-cab-service.jpg",
"description": "Book Mumbai cab service for local travel, airport transfers, outstation trips, corporate rides, and family travel. Mumbai Airport Cabs offers 24x7 reliable taxi service with professional drivers, clean vehicles, affordable pricing, and instant online booking across Mumbai.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-cab-service"
}
};





    return (
        <div>


<Helmet>
  <title>Mumbai Cab Service | 24x7 Taxi Booking | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai cab service for local, airport, outstation, corporate, and family travel. 24x7 reliable taxi service with affordable fares, professional drivers, and instant booking."
/>

<meta
 name="keywords"
 content="mumbai cab service, best mumbai cab service, mumbai taxi service, local cab service mumbai, mumbai ride service, mumbai car hire service, mumbai outstation cab service, mumbai airport cab service, 24x7 mumbai cab service, affordable mumbai cab service, mumbai online cab booking, mumbai instant cab service, mumbai city cab service, mumbai premium cab service, mumbai budget cab service, mumbai corporate cab service, mumbai family cab service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaicabservice;